module.exports = __webpack_public_path__ + "static/media/ic-experience.928f8375.webp";